import { Container } from 'inversify';

export function setup(container: Container) {
}



// WEBPACK FOOTER //
// ./src/app/crm/crm.config.ts